<template>
  <!--<transition name="anime" enter-active-class="animated slideInLeft"-->
              <!--leave-active-class="animated slideOutLeft">-->
    <div class="candidate CandidateType.vue full-container" @click="autoCloseSelect">
      <!--<main-menu></main-menu>-->
      <div class="candidate__content">
        <a href="javascript:;" class="go-back" @click="goBack()">
          <arrowBack></arrowBack>
        </a>

        <h1 class="title-primary text-center animated fadeInDown delay1000ms">
          Show de bola <span class="sub"> {{ guestName }}!</span>
        </h1>
        <!-- /.title-primary -->


        <div class="colm animated fadeInDown delay1500ms">
          <div class="candidate__text text-second">
            Pessoas competentes são nosso principal ativo. E se você é um bom profissional e tem potencial, temos muito interesse em te conhecer melhor
          </div>
          <!-- /.text -->
        </div>
        <div class="colm animated fadeInDown delay1500ms">
          <div class="candidate__selector">

            <div class="fake-selector" v-bind:class="{'open': select.isOpen}">
              <div class="current" @click="toggleFakeSelect">
                {{select.value}}
                <i class="arrow simple down"></i>
                <!-- /.arrow simple -->
              </div>
              <!-- /.current -->
              <div class="escolhas animated zoomIn">
                  <span
                    @click="setSelectValue(item)"
                    v-for="item in select.choices"
                    v-bind:class="{'selected': select.value === item}"
                  >{{ item }}</span>
              </div>
              <!-- /.choices -->
            </div>
            <!-- /.fake-selector -->
            <button @click="goToCandidatePosition" class="btn btn-bold btn-lg">OK <i class="arrow simple"></i></button>
            <!-- /.btn btn-bold -->

          </div>
          <!-- /.candidate__selector -->
        </div>
      </div>


      <!-- /.content -->
    </div>
  <!--</transition>-->
</template>

<script>
//  import MainMenu from './MainMenu.vue'
  import arrowBack from './arrowBack.vue'

  export default {
    name: 'CandidateType',
    data() {
      return {
        select: {
          isOpen: false,
          value: 'Sou um estudante',
          choices: [
            'Sou um estudante',
            'Sou um profissional júnior',
            'Sou um profissional analista',
            'Sou um profissional sênior',
            'Sou um profissional lider',
          ]
        }
      }
    },
    components: {
//      MainMenu,
      arrowBack
    },
    computed: {
      guestName() {
        return this.$store.getters.guestFirstName;
      }
    },
    mounted(){
      this.log('mounted: ' + this.$options.name);
      // seta a classe do menu principal
      this.$store.commit('setMenuClass', '');
    },
    methods: {
      goBack(){
       this.$router.go(-1);
      },
      goToCandidatePosition(){
        this.$store.commit('setCandidateType', this.select.value);
        this.$router.push('candidate/position');
      },
      toggleFakeSelect() {
        this.select.isOpen = !this.select.isOpen;
      },
      setSelectValue(val) {
        this.select.value = val;
        this.select.isOpen = false;
      },
      /**
       * Fecha as opções do select quando clicar na página
       * @param event
       */
      autoCloseSelect(event) {
        if ($('.fake-selector.open') !== null) {
          if (!$(event.target).is('.current')) {
            this.select.isOpen = false;

          }
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/CandidateType.vue